import React from 'react'
import Box from "@mui/material/Box";

import './CalculatePage.scss'
import {CalcPageInfo} from "./CalcPageInfo";
import classnames from "classnames";
import {LocationModal} from "../DealPage/LocationModal";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import {useCalcContext} from "../../contexts/CalcContext";
import {LEASE_DEAL_LIGHT} from "../../contexts/DealContext";
import Button from "@mui/material/Button";
import {MiniLeadItem} from "../DealPage/DealCRMPage/MiniLeadItem";
import {useModalsStore} from "../../stores/modalsStore";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";

export const CalculatePage = () => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const { calcState, resetCalcState, getLeadId } = useCalcContext()

    const isPurchase = calcState.is_purchase

    return (
        <Box id={"CalculatePage"}
             className={classnames('', {
                 isPurchase: isPurchase
             })}
        >
            <Stack
                // Align content to the top of the page (remove vertical centering)
                justifyContent={'flex-start'}
                style={{ width: '100%' }}
            >
                <div className="calc-page-header">
                    <div className="header-title-wrap">
                        <h1>Calculate</h1>
                        {
                            getLeadId() &&
                                <React.Fragment>
                                    <span className="header-for-lead"> for lead</span>
                                    <MiniLeadItem leadId={getLeadId()}/>
                                </React.Fragment>
                        }
                    </div>
                    <Button
                        className={'btn-reset'}
                        onClick={resetCalcState}
                    >
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/>
                            <path d="M3 3v5h5"/>
                        </svg>
                        Reset
                    </Button>
                </div>

                <CalcPageInfo />
            </Stack>
        </Box>
    )
}
